<template>
  <security-page>
    <template #left>
      <page-illustration :src="illustration" />
    </template>
    <template #right>
      <reset-password-form />
    </template>
  </security-page>
</template>

<script>
import SecurityPage from "@/views/security/components/SecurityPage.vue";
import PageIllustration from "@/views/security/components/PageIllustration.vue";
import ResetPasswordForm from "@/views/security/components/ResetPasswordForm.vue";

export default {
  components: {
    SecurityPage,
    PageIllustration,
    ResetPasswordForm,
  },
  data() {
    return {
      // eslint-disable-next-line global-require
      illustration: require("@/assets/images/illustrations/new-password.svg"),
    };
  },
};
</script>
